import { render, staticRenderFns } from "./DeadlineDetails.vue?vue&type=template&id=1c632e15"
import script from "./DeadlineDetails.vue?vue&type=script&lang=js"
export * from "./DeadlineDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports